import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  container: {
    padding: "40px 0px 15px 0px",
  },
}));
